var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7612 11.6916C27.3616 12.0109 27.8638 12.4875 28.214 13.0704C28.5642 13.6532 28.7492 14.3204 28.7492 15.0004C28.7492 15.6804 28.5642 16.3475 28.214 16.9304C27.8638 17.5133 27.3616 17.9899 26.7612 18.3091L10.7463 27.0179C8.1675 28.4204 5 26.5954 5 23.7104V6.29163C5 3.40413 8.1675 1.58038 10.7463 2.98163L26.7612 11.6916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.a35c5719ab21102a72665d5b62b2693e.svg";
export { ForwardRef as ReactComponent };